function easeOutQuint(t: number) {
  return 1 + --t * t * t * t * t
}

export class VerticalScroll {
  container: HTMLElement

  constructor(container) {
    this.container = container
  }

  to(top: number, duration: number = 1000) {
    const from = this.container.scrollTop
    const distance = top - from
    let startTime: null | number = null

    // rAF loop
    const loop = currentTime => {
      if (!startTime) {
        startTime = currentTime - 1
      }

      const timeElapsed = currentTime - startTime
      this.container.scrollTop = from + distance * easeOutQuint(timeElapsed / duration)

      if (timeElapsed < duration) {
        window.requestAnimationFrame(loop)
      } else {
        this.container.scrollTop = top
      }
    }

    window.requestAnimationFrame(loop)
  }
}

export class HorizontalScroll {
  container: HTMLElement

  constructor(container) {
    this.container = container
  }

  to(left: number, duration: number = 1000) {
    const from = this.container.scrollLeft
    const distance = left - from
    let startTime: number | null = null

    // rAF loop
    const loop = currentTime => {
      if (!startTime) {
        startTime = currentTime - 1
      }

      const timeElapsed = currentTime - startTime
      this.container.scrollLeft = from + distance * easeOutQuint(timeElapsed / duration)

      if (timeElapsed < duration) {
        window.requestAnimationFrame(loop)
      } else {
        this.container.scrollLeft = left
      }
    }

    window.requestAnimationFrame(loop)
  }
}
